import React, { useState, useContext } from 'react';
import { Input } from 'antd';

import './Composer.scss';
import SocketClientContext from '../contexts/SocketClient';
import { MESSAGE_SUBMIT_TOPIC, getInitiativeName } from '../api';
import { USER_NAME_STORAGE_KEY } from './UserNameModal';
import { useGlobalState } from '../state';

const TEXT_AREA_SIZE = { minRows: 1, maxRows: 10 }

const INITIATIVE_NAME = getInitiativeName();

function Composer() {
  const [value, setValue] = useState('');
  const socketClient = useContext(SocketClientContext);
  const [currentChannel,] = useGlobalState('currentChannel');
  return (
    <div className="__Composer__">
      <Input.TextArea
        autoFocus
        value={value}
        onChange={event => { setValue(event.target.value) }}
        autosize={TEXT_AREA_SIZE}
        onPressEnter={async (event) => {
          socketClient.send(
            MESSAGE_SUBMIT_TOPIC,
            {},
            JSON.stringify({
              message: event.target.value,
              initiative: INITIATIVE_NAME,
              type: 'message',
              branch: currentChannel,
              user: localStorage.getItem(USER_NAME_STORAGE_KEY)
            })
          );
          setValue('');
          event.preventDefault();
        }}
      />
    </div>
  );
}

export default Composer;
